export default __webpack_public_path__ + "static/media/beaker.80691ecf.png";